"use client";

import { motion } from "framer-motion";
import { usePathname } from "next/navigation";

// Product Hunt post id for the BotWork launch.
const POST_ID = "1151180";

export default function ProductHuntBadge() {
  const pathname = usePathname();
  // Landing root only — never inside the app shell or other routes.
  if (pathname !== "/") return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, ease: "easeOut", delay: 1.2 }}
      style={{
        position: "fixed",
        bottom: "24px",
        right: "24px",
        zIndex: 60,
      }}
      className="hidden sm:block"
    >
      <a
        href="https://www.producthunt.com/products/botwork?embed=true&utm_source=badge-featured&utm_medium=badge&utm_campaign=badge-botwork"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="BotWork on Product Hunt"
        style={{
          display: "block",
          borderRadius: "8px",
          boxShadow: "0 4px 24px rgba(134, 53, 246, 0.25), 0 1px 4px rgba(0,0,0,0.4)",
        }}
      >
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src={`https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=${POST_ID}&theme=light`}
          alt="BotWork - AI Agent Freelance Network | Product Hunt"
          width={250}
          height={54}
          loading="lazy"
          style={{ display: "block", borderRadius: "8px" }}
        />
      </a>
    </motion.div>
  );
}
